import React, { useRef } from 'react';
import {
  IncidentCreateModal,
  IncidentInfoModal,
} from '../../Incidents/IncidentModals';
import { Callout, DirectionalHint } from '@fluentui/react';
import { IIncident } from '../../../pages/Incidents/interfaces';
import { assertNotNil } from '../../../utils/types';
import { IconName, SvgIcon } from '../../Icon';

interface IProps {
  viewBox?: any;
  incidentKey?: string;
  currentIncident?: IIncident;
  incidents?: IIncident[];
  incidentIcon?: IconName;
  incidentColor?: string;
  activeIndex?: number;
  analysisId: string;
  createIncident?: boolean;
  selectedDate?: any;
  isCreateIncidentModalOpen?: boolean;
  closeCreateIncident?: () => void;
  setActiveIndex?: (page: number) => void;
  isInfoPopupOpen?: boolean;
  setInfoPopupOpen?: (a: string) => void;
}

export default function CustomReferenceLineLabel({
  incidentKey,
  viewBox,
  currentIncident,
  incidents,
  incidentIcon,
  incidentColor,
  activeIndex,
  analysisId,
  createIncident,
  selectedDate,
  isCreateIncidentModalOpen,
  closeCreateIncident,
  setActiveIndex,
  isInfoPopupOpen,
  setInfoPopupOpen,
}: IProps) {
  // TODO XXX viewBox is never passed to this?
  const { x, y, height } = viewBox;

  const onTriggerClick = () => {
    if (isInfoPopupOpen) {
      closePopup();
    } else {
      setInfoPopupOpen?.(incidentKey!);
    }
  };
  const closeParentPopup = () => null;
  const targetRef = useRef<any>();

  const closePopup = () => {
    setInfoPopupOpen?.('');
  };

  if (createIncident) {
    return (
      <>
        {isCreateIncidentModalOpen && (
          <Callout
            target={targetRef}
            directionalHint={DirectionalHint.rightCenter}
            onDismiss={closeCreateIncident}
          >
            <IncidentCreateModal
              analysisId={analysisId}
              selectedStartDate={selectedDate}
              onClose={closeCreateIncident}
              startDateReadOnly
              stopMovementPropagation
              closeOnScroll
            />
          </Callout>
        )}
        <foreignObject x={x} y={(y + height) / 2} ref={targetRef} />
      </>
    );
  }

  if (isInfoPopupOpen) {
    assertNotNil(currentIncident);
  }

  return (
    <>
      {isInfoPopupOpen && (
        <Callout
          target={targetRef}
          directionalHint={DirectionalHint.rightCenter}
          onDismiss={onTriggerClick}
        >
          <IncidentInfoModal
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            currentIncident={currentIncident!}
            incidents={incidents}
            closeParentPopup={closeParentPopup}
            analysisId={analysisId}
            stopMovementPropagation
            dismiss={closePopup}
          />
        </Callout>
      )}
      <foreignObject
        ref={targetRef}
        onClick={onTriggerClick}
        height="16"
        width="16"
        x={x - 8}
        y={y - 16}
        style={{ cursor: 'pointer' }}
      >
        <SvgIcon
          name={incidentIcon ?? `incidents`}
          color={incidentColor}
          width={16}
          height={16}
        />
      </foreignObject>
    </>
  );
}
